const {
    PERSONAL_LOAN_WAFFER,
    EASY_LOAN_WAFFER,
    OVERDRAFT_LOAN_WAFFER
} = require('constants/flagBasedFeatures');

const LOANS_MORTGAGES_LEGAL_FOOTER = [
    {
        id: "mortgage",
        featureFlag: true,
        poEditorKeys: [
            "loansLegalFooter-loansLegalFooterl_firstTerm",
            "loansLegalFooter-loansLegalFooterl_firstTerm_a",
        ]
    },
    {
        id: "personalLoan",
        featureFlag: PERSONAL_LOAN_WAFFER,
        poEditorKeys: [
            "loansLegalFooter-loansLegalFooterl_thirdTerm",
            "loansLegalFooter-loansLegalFooterl_fourTerm",
        ]
    },
    {
        id: "pregrantedCredit",
        featureFlag: OVERDRAFT_LOAN_WAFFER,
        poEditorKey: "loansLegalFooter-loansLegalFooterl_fiveTerm"
    },
    {
        id: "easyLoan",
        featureFlag: EASY_LOAN_WAFFER,
        poEditorKey: "loansLegalFooter-loansLegalFooterl_easyLoan"
    }
]

module.exports = LOANS_MORTGAGES_LEGAL_FOOTER;
